import { Component } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'error-modal',
  templateUrl: './error-modal.component.html',
  styleUrls: ['./error-modal.component.scss']
})
export class ErrorModalComponent {
  title: string;
  description: string;
  errorCode: string;
  errorMessage: string;
  blockOperation: boolean;
  retryCallback: Function;

  constructor(public modalRef: BsModalRef) { }

  decline() { } //external override
  onDecline() {
    if (typeof this.decline == "function") this.decline();
    this.modalRef.hide()
  }

  onRetry(){
    if (typeof this.retryCallback == "function") this.retryCallback();
    this.modalRef.hide()
  }

}